import Alert from '@mui/material/Alert';

export default function EventCalendarWidget() {
  return <Alert severity='info'>Event Calendar Coming Soon</Alert>;
}
